import Vue from 'vue'
import Router from 'vue-router'
import Unknown from '@/components/404'
import Home from '@/components/Home'

// // Prana
// import FunktionsweisePrana from '@/components/Prana/Funktionsweise'
// import VorteilePrana from '@/components/Prana/Vorteile'
// import ProduktePrana from '@/components/Prana/Produkte'
// 	import ProduktPrana150 from '@/components/Prana/Produkte/Prana-150'
// 	import ProduktPrana200G from '@/components/Prana/Produkte/Prana-200G'
// 	import ProduktPrana200C from '@/components/Prana/Produkte/Prana-200C'
// 	import ProduktPrana250 from '@/components/Prana/Produkte/Prana-250'
// 	import ProduktPrana340A from '@/components/Prana/Produkte/Prana-340A'
// 	import ProduktPrana340S from '@/components/Prana/Produkte/Prana-340S'
// import GalleriePrana from '@/components/Prana/Gallerie'

// // Solar Fox
// import FunktionsweiseSolarfox from '@/components/Solar-Fox/Funktionsweise'
// import VorteileSolarfox from '@/components/Solar-Fox/Vorteile'
// import ProdukteSolarfox from '@/components/Solar-Fox/Produkte'
// import GallerieSolarfox from '@/components/Solar-Fox/Gallerie'

// // Termofol
// import FunktionsweiseTermofol from '@/components/Termofol/Funktionsweise'
// import VorteileTermofol from '@/components/Termofol/Vorteile'
// import ProdukteTermofol from '@/components/Termofol/Produkte'

import Dokumentation from '@/components/Dokumentation'
import Dokumentation_HAQCS from '@/components/Dokumentation/Dokumentation_HAQCS'
import Angebot from '@/components/Angebot'
import Kontakt from '@/components/Kontakt'
import PrivacyPolicy from '@/components/PrivacyPolicy'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		// DEUTSCH
		{
			path: '/dokumentation',
			name: 'de Dokumentation',
			component: Dokumentation,
			meta: { lng:'de', name:'Dokumentation', lngPath:{ de:'/dokumentation', en:'/docs', pl:'/dokumentacja' } }
		},
		{
			path: '/dokumentation/haqcs',
			name: 'de Dokumentation_HAQCS',
			component: Dokumentation_HAQCS,
			meta: { lng:'de', name:'Dokumentation', lngPath:{ de:'/dokumentation/haqcs', en:'/docs/haqcs', pl:'/dokumentacja/haqcs' } }
		},
		// {
		// 	path: '/dokumentation/:heading',
		// 	name: 'de Dokumentation (heading)',
		// 	component: Dokumentation_HAQCS,
		// 	meta: { lng:'de', name:'Dokumentation', lngPath:{ de:'/dokumentation/:heading', en:'/docs/:heading', pl:'/dokumentacja/:heading' } }
		// },
		{
			path: '/angebot/',
			name: 'de Angebot',
			component: Angebot,
			meta: { lng:'de', name:'Angebot', lngPath:{ de:'/angebot', en:'/offer', pl:'/oferta' } }
		},
		{
			path: '/angebot/:viewedDevice',
			name: 'de Angebot (viewedDevice)',
			component: Angebot,
			meta: { lng:'de', name:'Angebot', lngPath:{ de:'/angebot/:viewedDevice', en:'/offer/:viewedDevice', pl:'/oferta/:viewedDevice' } }
		},
		{
			path: '/Kontakt',
			name: 'de Kontakt',
			component: Kontakt,
			meta: { lng:'de', name:'Kontakt', lngPath:{ de:'/kontakt', en:'/contact', pl:'/kontakt_pl' } }
		},

		// ENGLISH
		{
			path: '/docs',
			name: 'en Dokumentation',
			component: Dokumentation,
			meta: { lng:'en', name:'Documentation', lngPath:{ de:'/dokumentation', en:'/docs', pl:'/dokumentacja' } }
		},
		{
			path: '/docs/haqcs',
			name: 'en Dokumentation_HAQCS',
			component: Dokumentation_HAQCS,
			meta: { lng:'en', name:'Documentation', lngPath:{ de:'/dokumentation/haqcs', en:'/docs/haqcs', pl:'/dokumentacja/haqcs' } }
		},
		// {
		// 	path: '/docs/:heading',
		// 	name: 'en Dokumentation (heading)',
		// 	component: Dokumentation_HAQCS,
		// 	meta: { lng:'en', name:'Documentation', lngPath:{ de:'/dokumentation/:heading', en:'/docs/:heading', pl:'/dokumentacja/:heading' } }
		// },
		{
			path: '/offer/',
			name: 'en Angebot',
			component: Angebot,
			meta: { lng:'en', name:'Offer', lngPath:{ de:'/angebot', en:'/offer', pl:'/oferta' } }
		},
		{
			path: '/offer/:viewedDevice',
			name: 'en Angebot (viewedDevice)',
			component: Angebot,
			meta: { lng:'en', name:'Offer', lngPath:{ de:'/angebot/:viewedDevice', en:'/offer/:viewedDevice', pl:'/oferta/:viewedDevice' } }
		},
		{
			path: '/Contact',
			name: 'en Kontakt',
			component: Kontakt,
			meta: { lng:'en', name:'Contact', lngPath:{ de:'/kontakt', en:'/contact', pl:'/kontakt_pl' } }
		},
		{
			path: '/Privacy-Policy',
			name: 'Privacy Policy',
			component: PrivacyPolicy,
			meta: { lng:'en', name:'Privacy Policy', lngPath:{ de:'/privacy-policy', en:'/privacy-policy', pl:'/privacy-policy' } }
		},

		// POLSKI
		{
			path: '/dokumentacja',
			name: 'pl Dokumentation',
			component: Dokumentation,
			meta: { lng:'pl', name:'Dokumentacja', lngPath:{ de:'/dokumentation', en:'/docs', pl:'/dokumentacja' } }
		},
		{
			path: '/dokumentacja/haqcs',
			name: 'pl Dokumentation_HAQCS',
			component: Dokumentation_HAQCS,
			meta: { lng:'pl', name:'Dokumentacja', lngPath:{ de:'/dokumentation/haqcs', en:'/docs/haqcs', pl:'/dokumentacja/haqcs' } }
		},
		// {
		// 	path: '/dokumentacja/:heading',
		// 	name: 'pl Dokumentation (heading)',
		// 	component: Dokumentation_HAQCS,
		// 	meta: { lng:'pl', name:'Dokumentacja', lngPath:{ de:'/dokumentation/:heading', en:'/docs/:heading', pl:'/dokumentacja/:heading' } }
		// },
		{
			path: '/oferta/',
			name: 'pl Angebot',
			component: Angebot,
			meta: { lng:'pl', name:'Oferta', lngPath:{ de:'/angebot', en:'/offer', pl:'/oferta' } }
		},
		{
			path: '/oferta/:viewedDevice',
			name: 'pl Angebot (viewedDevice)',
			component: Angebot,
			meta: { lng:'pl', name:'Oferta', lngPath:{ de:'/angebot/:viewedDevice', en:'/offer/:viewedDevice', pl:'/oferta/:viewedDevice' } }
		},
		{
			path: '/kontakt_pl',
			name: 'pl Kontakt',
			component: Kontakt,
			meta: { lng:'pl', name:'Kontakt', lngPath:{ de:'/kontakt', en:'/contact', pl:'/kontakt_pl' } }
		},

		// GENERAL
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {name:'Home'}
		},
		{
			path: '/:page',
			name: '',
			component: Unknown,
			meta: { col:2, noFooter:true }
		},
		{
			path: '/:page/:a',
			name: '',
			component: Unknown,
			meta: { col:2, noFooter:true }
		},
		{
			path: '/:page/:a/:b',
			name: '',
			component: Unknown,
			meta: { col:2, noFooter:true }
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js